import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";
class AgentApplicationsService extends BaseCollectionService {
  constructor() {
    super("agent-applications");
  }
  public async printAgentApplicationById(
    payload: any
  ): Promise<ResponseWrapper> {
    const path = `/agent-applications/print/${payload._id}`;
    return await this.request(
      {
        method: "get",
        url: path
      },
      { useToken: "access" }
    );
  }
  public async deleteBulk(
    agentApplicationIds: string[]
  ): Promise<ResponseWrapper> {
    const path = `agent-applications/bulk-delete`;
    return await this.request(
      { method: "put", url: path, data: { agentApplicationIds } },
      { useToken: "access" }
    );
  }
  createAgentApplication(payload: Record<string, any>) {
    return this.request({
      method: "post",
      url: `/${this.collection}`,
      data: payload
    });
  }
}

export default new AgentApplicationsService();
